"use client";

import {
  BoldPlugin,
  CodePlugin,
  HighlightPlugin,
  ItalicPlugin,
  KbdPlugin,
  StrikethroughPlugin,
  SubscriptPlugin,
  SuperscriptPlugin,
  UnderlinePlugin,
} from "@platejs/basic-nodes/react";
import {
  BoldRules,
  CodeRules,
  HighlightRules,
  ItalicRules,
  MarkComboRules,
  StrikethroughRules,
  SubscriptRules,
  SuperscriptRules,
  UnderlineRules,
} from "@platejs/basic-nodes";

import { CodeLeaf } from "../../ui/code-node";
import { HighlightLeaf } from "../../ui/highlight-node";
import { KbdLeaf } from "../../ui/kbd-node";

export const BasicMarksKit = [
  BoldPlugin.configure({
    inputRules: [BoldRules.markdown(), MarkComboRules.markdown({ variant: "boldItalic" })],
  } as any),
  ItalicPlugin.configure({
    inputRules: [ItalicRules.markdown()],
  } as any),
  UnderlinePlugin.configure({
    inputRules: [UnderlineRules.markdown()],
  } as any),
  CodePlugin.configure({
    node: { component: CodeLeaf },
    shortcuts: { toggle: { keys: "mod+e" } },
    inputRules: [CodeRules.markdown()],
  } as any),
  StrikethroughPlugin.configure({
    shortcuts: { toggle: { keys: "mod+shift+x" } },
    inputRules: [StrikethroughRules.markdown()],
  } as any),
  SubscriptPlugin.configure({
    shortcuts: { toggle: { keys: "mod+comma" } },
    inputRules: [SubscriptRules.markdown()],
  } as any),
  SuperscriptPlugin.configure({
    shortcuts: { toggle: { keys: "mod+period" } },
    inputRules: [SuperscriptRules.markdown()],
  } as any),
  HighlightPlugin.configure({
    node: { component: HighlightLeaf },
    shortcuts: { toggle: { keys: "mod+shift+h" } },
    inputRules: [HighlightRules.markdown()],
  } as any),
  KbdPlugin.withComponent(KbdLeaf),
];
